 
import ReusableTest from "../ReusableComponent";
import { useContext } from "react";
import { NavContext } from "../../../../../components/Layout/Backend/Layout";


function Test() {

  const navContext = useContext(NavContext);
  const pteCore = navContext?.pteCore ?? false; // Default to Academy if undefined

  return (
    <ReusableTest
      category="rts"
      path="get-test-post-rts"
      beginningCounterCount={20}
      playingCounterCount={5}
      recordingTotalCount={40}
      PTECore={pteCore}
    ></ReusableTest>
  );
}

export default Test;
